import styled, { css } from 'styled-components';
import { Avatar, DropdownMenu, Spinner } from '@bimone/bimtrackreactcomponents';

export const StyledNavBar = {
  Container: styled.div`
    ${({ theme: { colors, fonts, metrics } }) => css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: stretch;
      background: ${colors.grey.lightest};
      border-bottom: solid ${metrics.rem(1)} ${colors.grey.lightPlus};
      height: ${metrics.rem(57)};
      padding: 0 0 0 ${metrics.rem(32)};
      font-size: 16px;
      font-family: ${fonts.family.BOOK};
      font-style: normal;
      font-weight: normal;
      line-height: 1.25;

      & > *:not(:last-child) {
        margin-right: ${metrics.rem(8)};
      }
    `}
  `,
  Entities: {
    Container: styled.div`
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      flex-grow: 1;
    `,
    SelectorContainer: styled.div`
      width: 15em;
    `,
    Chevron: styled.div`
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 0.5em;
      flex-grow: 0;
    `,
    Spinner: styled(Spinner)`
      ${({ theme: { metrics } }) => css`
        margin: auto ${metrics.rem(4)};
      `}
    `,
  },
  User: {
    Container: styled.div`
      display: flex;
      justify-content: stretch;
      align-items: center;
      cursor: pointer;
      ${({ theme: { metrics } }) => css`
        padding-right: ${metrics.rem(32)};
      `};
    `,
    Avatar: Avatar,
    DropdownContainer: styled.div<{ x: number | string; y?: number | string }>`
      ${({ x, y }) => css`
        top: ${y}px;
        left: ${x}px;
        position: absolute;
      `}
    `,
    DropdownMenu: DropdownMenu,
  },
};
